import React from 'react';
import { Day } from '@material-ui/pickers';

export default (date, selectedDate, dayInCurrentMonth, originalComponent, w) => {
  const first = date.day() === 1;
  const { props } = originalComponent;

  return (
    <div className={first ? 'material-ui-pickers-day' : ''}>
      {first && <div className="material-ui-pickers-week-number">{w}.{date.isoWeek()}</div>}
      <Day
        {...props}
      >
        {date.date()}
      </Day>
    </div>
  );
};
